import { Collection } from 'modules/core/lib/mobx-rest'

import Membership from 'modules/teams/store/models/Membership'

class Memberships extends Collection<Membership> {
  get cacheKey(): string {
    return 'memberships'
  }

  get indexes() {
    return ['employee_id', 'team_id']
  }

  model() {
    return Membership
  }
}

const singleton: Memberships = new Memberships()

export { Memberships }

export default singleton
